import {mount} from 'svelte'
import '../src/utils/ArrayExtensions'

import '../css/account.css'
import '../css/chartist.css'
import '../css/collections.css'
import '../css/comments.css'
import '../css/dropdown.css'
import '../css/editor.css'
import '../css/main.scss'
import '../css/menu.css'
import '../css/modal.css'
import '../css/p-font.scss'
import '../css/poem.css'
import '../css/poem-modal.scss'
import '../css/poet.css'
import '../css/poets.css'
import '../css/profile.css'
import '../css/reset.css'
import '../css/sidebar.css'
import '../css/socicon.scss'
import '../css/transition.css'

import App from '../src/App.svelte'
import {initTranslations, t} from '../src/i18n'
import {flash} from '../src/stores/flash'

await initTranslations()

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  console.error(event)
  flash.show(t.flash.errors.unknown, 'error')
})

const app = mount(App, {
  target: document.getElementById('app')!
})

export default app
